import MoneroCheck from "./MoneroCheck";
/**
 * Results from checking a transaction key.
 */
export default class MoneroCheckTx extends MoneroCheck {
    constructor(check) {
        super(check);
        if (this.receivedAmount !== undefined && typeof this.receivedAmount !== "bigint")
            this.receivedAmount = BigInt(this.receivedAmount);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getReceivedAmount() !== undefined)
            json.receivedAmount = this.getReceivedAmount().toString();
        return json;
    }
    getInTxPool() {
        return this.inTxPool;
    }
    setInTxPool(inTxPool) {
        this.inTxPool = inTxPool;
        return this;
    }
    getNumConfirmations() {
        return this.numConfirmations;
    }
    setNumConfirmations(numConfirmations) {
        this.numConfirmations = numConfirmations;
        return this;
    }
    getReceivedAmount() {
        return this.receivedAmount;
    }
    setReceivedAmount(receivedAmount) {
        this.receivedAmount = receivedAmount;
        return this;
    }
}
